import { createQueryParams } from '@nexio/emvio-util-app';
import config from '../../config/config';
import { buildTableSuccessActionBasedOnCount } from '../../utils/actionCreators';
import { goToUrl } from '../Table/tableActions';
import moment from 'moment';

export const RESIDUALS_LOAD = 'RESIDUALS/RESIDUALS_LOAD';
export const RESIDUALS_SUCCESS = 'RESIDUALS/RESIDUALS_SUCCESS';
export const RESIDUALS_FAILURE = 'RESIDUALS/RESIDUALS_FAILURE';

export const fetchUrl = `${config.residualApiUrl}/reseller/agent`;

export function getResiduals(filters, page, pageSize, sorters) {
    const queryParamsString = createQueryParams({
        dateKey: 'reportDate',
        filters,
        page,
        pageSize,
        sorters
    });

    return {
        failureActionTypeOrCreator: getResidualsFailureActionCreator,
        fetchParams: {
            url: `${fetchUrl}${queryParamsString}`
        },
        loadActionTypeOrCreator: RESIDUALS_LOAD,
        successActionTypeOrCreator: getResidualsSuccessActionCreator
    };
}

export function getResidualsSuccessActionCreator(results) {
    return buildTableSuccessActionBasedOnCount(results, RESIDUALS_SUCCESS, 'residuals');
}

export function getResidualsFailureActionCreator(error) {
    return {
        error,
        type: RESIDUALS_FAILURE
    };
}

export function goToAgentResiduals(history, residual, newTab) {
    const reportDate = residual.reportDate;
    const endDate =  moment(reportDate).add(10, 'days').format('YYYY-MM-DD');

    goToUrl(history, `residuals/agent/${residual.agentId}?startDate=${reportDate}&endDate=${endDate}`, newTab);
}
